import React, { ReactNode } from "react";
import { Button, HXIcon, ImageKit } from "@aph/ui-lib-humanx";
import { DeviceInfo } from "@/interface/deviceInfo";
import styles from "./BabyLookLike.module.scss";

interface BabyLookLikeProps {
  onCtaClick?: (e?: any) => void;
  onClick?: (e?: any) => void;
  title: string;
  iconUrl?: string;
  ctaText?: string;
  backgroundColour: string;
  className?: string;
  iconAlt?: string;
  description?: string;
  isWithoutCta?: boolean;
  redirectUrl?: string;
  userAgent?: DeviceInfo;
}

const BabyLookLike: React.FC<BabyLookLikeProps> = (props) => {
  const {
    title,
    iconUrl,
    ctaText,
    backgroundColour,
    onClick,
    className = "",
    iconAlt = title,
    description,
    isWithoutCta,
    redirectUrl,
    userAgent,
  } = props;

  return (
    <a
      href={redirectUrl}
      aria-label="babyLooLike Card"
      className={styles.anchorTag}
      onClick={(e) => e.preventDefault()}
    >
      <div
        style={{
          background: backgroundColour,
        }}
        onClick={onClick}
        className={`${styles.babyLookLike} ${className}`}
      >
        <div className={styles.cardContent}>
          {title && <div className={styles.title} dangerouslySetInnerHTML={{ __html: title }} />}
          <div className={`${styles.descriptionBox} ${isWithoutCta ? styles.desWithoutCta : ""}`}>
            <div className={styles.icon}>
              {iconUrl && (
                <ImageKit
                  src={iconUrl}
                  alt={iconAlt}
                  height={userAgent?.isDesktop ? 140 : 100}
                  width={userAgent?.isDesktop ? 140 : 100}
                />
              )}
              <div className={styles.iconBg}>
                <HXIcon order={1} className={styles.item2} backgroundColor={backgroundColour} size="100x100" />
              </div>
            </div>

            {description && <div dangerouslySetInnerHTML={{ __html: description }} className={styles.description} />}
          </div>
          {ctaText && (
            // TODO: Change to ButtonLink if this whole component is not going into UI lib
            <Button size="lg" className={styles.cta}>
              {ctaText}
            </Button>
          )}
        </div>
        <div className={styles.cardBg}>
          <div className={styles.twoIconStyle}>
            <HXIcon order={1} className={styles.item} backgroundColor={"#fff"} size="100x100" opacity=".2" />
          </div>
        </div>
      </div>
    </a>
  );
};

export default BabyLookLike;
